<template>
    <div class="relative bg-wrap-color" v-loading="mixinLoading">
        <template v-if="isPageAllowed" >
            <div style="transition: none;">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" @tab-click="changeTab">
                        <el-tab-pane label="创意团队设置" name="creative_team_list" v-if="pageActionNames.includes('creative_team_list')"></el-tab-pane>
                        <el-tab-pane label="投放尺寸设置" name="size_list" v-if="pageActionNames.includes('size_list')"></el-tab-pane>
                        <el-tab-pane label="视频标签管理" name="video_tag_list" v-if="pageActionNames.includes('video_tag_list')"></el-tab-pane>
                        <el-tab-pane label="图片标签管理" name="img_tag_list" v-if="pageActionNames.includes('img_tag_list')"></el-tab-pane>
                        <el-tab-pane label="工单标签管理" name="work_order_label_list" v-if="pageActionNames.includes('work_order_label_list')"></el-tab-pane>
                        <el-tab-pane label="产能录入" name="production_capacity_list" v-if="pageActionNames.includes('production_capacity_list')"></el-tab-pane>
                        <el-tab-pane label="产能配置" name="capacity_config_list" v-if="pageActionNames.includes('capacity_config_list')"></el-tab-pane>
                        <el-tab-pane label="集团星级" name="bloc_star_list" v-if="pageActionNames.includes('bloc_star_list')"></el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div class="pl10 pr10 pb10">
                <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5">
                    <keep-alive :include="keepList">
                        <component
                            :is="componentName"
                            :page-func="tabPageFunc"
                            :plat-list="platList"
                        />
                    </keep-alive>
                </div>
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>素材工单</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex';
    import {pageMixin} from '../../mixins/pageMixin';
    import NoPermissionInfo from "@/components/noPermissionInfo.vue";
    import creative_team_list from "./pages/teamList";
    import size_list from "./pages/sizeList";
    import video_tag_list from "./pages/videoTagList";
    import img_tag_list from "./pages/imageTagList";
    import work_order_label_list from "./pages/workOrderTaglList";
    import production_capacity_list from "./pages/capacityInputList";
    import capacity_config_list from "./pages/capacityConfigDashboard";
    import bloc_star_list from "./pages/blocStarList";
    import API from '@/api/workOrder/conf.js';



    export default {
        name: 'ConfigIndex',
        components: {
            NoPermissionInfo,
            creative_team_list,
            size_list,
            video_tag_list,
            img_tag_list,
            work_order_label_list,
            production_capacity_list,
            capacity_config_list,
            bloc_star_list
        },
        mixins: [pageMixin],
        data() {
            return {
                activeTabName:'',
                componentName: '',
                keepList:['creative_team_list','size_list','video_tag_list','img_tag_list','work_order_label_list','production_capacity_list','capacity_config_list','bloc_star_list'],
                platList:[],        // 包含一些自定义的媒体
            }
        },
        computed:{
            tabPageFunc(){
                let pageAction = this.pageAction||[];
                let tabItem = pageAction.find(item=>item.name===this.activeTabName);
                return tabItem?tabItem.func||[]:[];
            },
        },
        created() {
            this.getSizeConfigPlatList();
        },
        methods: {
            ...mapMutations('app', [
                'CHANGE_BREADCRUMB',
                'CLEAR_BREADCRUMB'
            ]),
            initPageStates(){
                let defaultTab = localStorage.getItem("work_order_material_conf_tab");
                this.activeTabName = defaultTab||this.pageActionNames[0]||'';
                this.componentName = defaultTab||this.pageActionNames[0]||'';
                this.appendBreadcrumb(this.componentName);
            },
            changeTab(tab){
                console.log('changeTab',tab.name,this.activeTabName);
                this.componentName = tab.name;
                localStorage.setItem("work_order_material_conf_tab",tab.name);
                this.appendBreadcrumb(this.componentName);
            },
            getSizeConfigPlatList(){
                API.getSizeConfigPlatList().then(res=>{
                    this.platList = (res.data||[]).map(item=>{
                        return {
                            id:item.plat_id,
                            name:item.plat_name,
                        }
                    })
                })
            },
            appendBreadcrumb(name){
                let map = {
                    creative_team_list:'创意团队设置',
                    size_list:'投放尺寸设置',
                    video_tag_list:'视频标签管理',
                    img_tag_list:'图片标签管理',
                    work_order_label_list:'工单标签管理',
                    production_capacity_list:'产能录入',
                    capacity_config_list:'产能配置',
                    bloc_star_list:'集团星级',
                };
                let tabName = map[name];
                this.CHANGE_BREADCRUMB([tabName]);
            },
        },
        beforeRouteLeave(to, from, next){
            localStorage.removeItem("work_order_material_conf_tab");
            this.CLEAR_BREADCRUMB();
            next();
        },
    }
</script>
<style lang="scss" scoped>
.tab-bar::after{
    content: '';
    position: absolute;
    left: -20px;
    right: -20px;
    background-color: #fff;
}
.tab-bar ::v-deep .el-tabs__header{
    background-color: #fff;
    margin-bottom: 10px;
    .el-tabs__nav-wrap{
        padding-left: 30px;
    }
    .el-tabs__active-bar {
        min-width: 56px;
    }
}
.tab-bar ::v-deep .el-tab-pane{
    margin: 0 15px;
}
.bg-wrap-color{
    padding: 0;
    background-color:#F1F4F9;
}
</style>
